import {normalizeData} from "../../../../modules/vegas/js/util";
import axios from "axios";

class Calculation {
	constructor() {
		this.calcResult = document.getElementById('calculation-result');
		this.calcResultError = document.getElementById('calculation-result-error');
		this.calcResultLoader = document.getElementById('calculation-result-loader');
		this.calcResultContent = document.getElementById('calculation-result-content');
		this.calcResultContentData = document.getElementById('calculation-result-content--data');
	}

	submit(form) {
		let values = new FormData(form);

		this.toggle(this.calcResultLoader, 'show');

		return this.request(form.action, new FormData(form));
	}

	request(route, formData) {
		const _this = this;

		axios.post(route, formData)
			.then((response) => {
				_this.toggle(_this.calcResultContent, 'show');
				_this.calcResultContentData.innerHTML = response.data;
			})
			.catch((response) => {
				_this.toggle(_this.calcResultError, 'show');
				throw new Error(response)
			});
	}

	toggle(el, status) {
		[...this.calcResult.querySelectorAll('.show')].forEach(elm => {
			elm.classList.remove('fade');
			setTimeout(() => elm.classList.remove('show'), 300);
		});

		if (status === 'show') {
			el.classList.add('show');
			setTimeout(() => el.classList.add('fade'), 300);
		}
	}
}

export default Calculation;
